export enum BulkAssignAction {
	ASSIGN = 'ASSIGN',
	UNASSIGN = 'UNASSIGN',
}
